var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7895 3H5.68421C4.75789 3 4 3.75789 4 4.68421V16.4737H5.68421V4.68421H15.7895V3ZM18.3157 6.36841H9.05251C8.12619 6.36841 7.3683 7.12631 7.3683 8.05262V19.8421C7.3683 20.7684 8.12619 21.5263 9.05251 21.5263H18.3157C19.242 21.5263 19.9999 20.7684 19.9999 19.8421V8.05262C19.9999 7.12631 19.242 6.36841 18.3157 6.36841ZM18.3158 19.8421H9.05267V8.05267H18.3158V19.8421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b84920d9f7c24750cf122fb414241b14.svg";
export { ForwardRef as ReactComponent };